import { Stage } from 'modules/case-tracking/types/case-tracking.enums';

export const stageText = (stage: Stage) => {
  switch (stage) {
    case Stage.Stage1:
      return 'Stage 1';
    case Stage.Stage2:
      return 'Stage 2';
    case Stage.Stage3:
      return 'Stage 3';
    case Stage.Stage4:
      return 'Stage 4';
    case Stage.Cancelled:
      return 'Cancelled';
    default:
      return '';
  }
};
